import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "./Receipt.css";

const API_URL = "https://payyug.in/api";

const Receipt = () => {
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchLedgers, setBranchLedgers] = useState([]);
  const [selectedBranchLedger, setSelectedBranchLedger] = useState(null);

  const [formData, setFormData] = useState({
    voucherType: "receipt",
    date: "",
    narration: "",
    amount: "",
    ledgerType: "",
    receiptAccount: "",
  });

  /* ================= FETCH BRANCH ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        console.log("branch", res.data.branches);
        setBranchs(res?.data?.branches || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH BRANCH LEDGER LIST================= */
  useEffect(() => {
    if(!selectedBranch){
      setBranchLedgers([]);
      return;
    }
    const fetchBranchLedgers = async () => {
      try {
        const res = await axios.get(`${API_URL}/branch-ledger/get-all`, {
          params: {
            superAdminId: localStorage.getItem("adminuserId"),
            branch_id: selectedBranch.id,
          },
        });
        console.log("branch ledgers", res.data);
        setBranchLedgers(res?.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranchLedgers();
  }, [selectedBranch]);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // console.log("selected branch ledger", selectedBranchLedger?.id);

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedBranch) {
      toast.error("Please select branch");
      return;
    }

    if (!selectedBranchLedger) {
      toast.error("Please select DR Account");
      return;
    }

    if (!formData.receiptAccount) {
      toast.error("Please select CR Account");
      return;
    }

    if (!formData.amount) {
      toast.error("Amount is required");
      return;
    }

    const adminId = Number(localStorage.getItem("adminuserId"));

    const payload = {
      voucherType: formData.voucherType,
      voucherNo: `PAY${Date.now()}`,
      date: formData.date,
      narration: formData.narration,
      branchId: selectedBranch.id,
      superAdminId: adminId,
      createdBy: adminId,

      entry: {
        ledgerId: Number(selectedBranchLedger?.id),
        amount: Number(formData.amount),
        ledgerType: selectedBranchLedger.ledger.name,
      },
      receiptAccountLedgerId: formData.receiptAccount === "Cash" ? 1 : 2,
    };

    try {
      const res=await axios.post(`${API_URL}/ledger-entry/create-voucher`, payload);

      toast.success(res.data?.message||"Receipt Voucher Created Successfully");

      // reset
      setFormData({
        voucherType: "receipt",
        date: "",
        narration: "",
        amount: "",
        ledgerType: "",
        receiptAccount: "",
      });

      setSelectedBranch(null);
      setSelectedBranchLedger(null);
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Failed to create payment voucher"
      );
    }
  };

  return (
    <div className="receipt-container">
      <h1 className="receipt-heading">Receipt Voucher</h1>

      <div className="receipt-top">
        <form className="receipt-form" onSubmit={handleSubmit}>
          <div className="receipt-form-section">
            {/* Branch */}
            <div className="receipt-form-input-fields">
              <label>Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value)
                  );
                  setSelectedBranch(branch);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Date */}
            <div className="receipt-form-input-fields">
              <label>Date</label>
              <input
              required
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </div>

            {/* Voucher Type */}
            <div className="receipt-form-input-fields">
              <label>Voucher Type</label>
            <input value="Receipt" style={{fontWeight:"600"}} disabled />
            </div>

            {/* CR Account */}
            <div className="receipt-form-input-fields">
              <label>CR. Account</label>
              <select
                name="receiptAccount"
                value={formData.receiptAccount}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Bank">Bank A/C</option>
                <option value="Cash">Cash</option>
              </select>
            </div>

            {/* DR Account */}
            <div className="receipt-form-input-fields">
              <label>DR. Account</label>
              <select
              disabled={!selectedBranch}
                value={selectedBranchLedger?.id || ""}
                onChange={(e) => {
                  const branchLedger = branchLedgers.find(
                    (bl) => bl.id === Number(e.target.value)
                  );
                  setSelectedBranchLedger(branchLedger);
                }}
              >
                <option value="">Select Branch Ledger</option>
                {branchLedgers.map((bl) => (
                  <option key={bl.id} value={bl.id}>
                    {bl.ledger.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Amount */}
            <div className="receipt-form-input-fields">
              <label>Amount</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Narration */}
          <div className="receipt-narration-input">
            <label>Narration</label>
            <textarea
            required
              name="narration"
              value={formData.narration}
              onChange={handleChange}
            />
          </div>

          <div className="receipt-form-submit-btn">
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Receipt;
